import {
  EContractType,
  IContract,
} from "@rentiohq/shared-frontend/dist/types/contract.types";

// The lease a cost payment names (prefill.contractId) when the form's own
// lists miss it: an open-ended lease (no end date) of the form's property. The
// "active" list asks an end date after today and the "ended" list one up to
// today, so such a lease is in neither. A lease missing from both for any
// other reason (another property's, not a rental lease) is not linked.
export const getOpenEndedPrefillContract = (params: {
  contract?: IContract;
  propertyId?: number;
  listedContracts: IContract[];
}): IContract | undefined => {
  const { contract, propertyId, listedContracts } = params;
  if (!contract || contract.stopDate != null) return undefined;
  if (contract.propertyId !== propertyId) return undefined;
  if (contract.contractType !== EContractType.Basic) return undefined;
  if (listedContracts.some(listed => listed.id === contract.id)) {
    return undefined;
  }
  return contract;
};
